// extracted by mini-css-extract-plugin
export default {"label":"OnboardingCreateProfileLabel_label__8A5Kh"};